import React from 'react';
import './Hero.css';

const Hero = ({ activeDot, handleDotClick }) => {
  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-left">
          <h1 className="hero-title">NoFace</h1>
          <p className="hero-description">
            Embrace the streets. Express your energy. Stay anonymous. Our streetwear collection 
            embodies the raw power of urban culture, where identity meets mystery and style meets rebellion.
          </p>
          <button className="hero-button">Shop Now</button>
        </div>
        <div className="hero-right">
          <div className="logo-display">
            <div className="hero-logo-container">
              <img src="/logo.png" alt="NoFace Brand Logo" className="hero-logo" />
            </div>
            <div className="geometric-bg">
              <div className="geometric-shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
                <div className="shape shape-4"></div>
                <div className="shape shape-5"></div>
              </div>
            </div>
          </div>
          <div className="carousel-dots">
            {[0, 1, 2, 3].map((index) => (
              <div
                key={index}
                className={`dot ${activeDot === index ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              ></div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
